module.exports = __webpack_public_path__ + "static/media/work-04-small.fdcad34e.jpg";